import '../../assets/product-list-assets/gbe-1u-2510.svg.mjs';
import EnterpriseSWIcon__default from "../../../../assets/gbe-1u.svg";
"use strict";
const productListSwitchingProfessional = {
  id: "productListSwitchingProfessional",
  title: "productListGroup.switchingProfessional.title",
  icon: {
    src: EnterpriseSWIcon__default,
    width: 24,
    height: 24
  }
};
export { productListSwitchingProfessional };
//# sourceMappingURL=productListSwitchingProfessional.mjs.map
